import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedMessage = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="message" size="100%" color={stroke ?? color} />
);

export { LineRoundedMessage };
